module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-card-media', {
    staticClass: "img-scale",
    attrs: {
      "height": _vm.height,
      "src": _vm.audio.imgSource,
      "alt": ""
    }
  }, [(_vm.audio.imgSource !== _vm.defaultImageSrc) ? _c('v-layout', {
    staticClass: "audio-overlay",
    attrs: {
      "align-center": ""
    }
  }, [(_vm.actions.play) ? _c('v-flex', {
    staticClass: "text-xs-center"
  }, [(_vm.audio.id === _vm.currentAudioId && _vm.player.state === 1) ? _c('v-btn', {
    attrs: {
      "large": _vm.height !== '42px',
      "small": _vm.height === '42px',
      "icon": "",
      "dark": "",
      "color": "secondary"
    },
    on: {
      "click": function($event) {
        _vm.$store.dispatch('pause')
      }
    }
  }, [_c('v-icon', [_vm._v("pause")])], 1) : _c('v-btn', {
    attrs: {
      "large": _vm.height !== '42px',
      "small": _vm.height === '42px',
      "icon": "",
      "dark": "",
      "color": "secondary"
    },
    on: {
      "click": function($event) {
        _vm.$store.dispatch('playAudio', _vm.audio)
      }
    }
  }, [_c('v-icon', [_vm._v("play_arrow")])], 1)], 1) : _vm._e(), _vm._v(" "), (_vm.actions.watchLater) ? _c('v-btn', {
    staticClass: "watch-later",
    attrs: {
      "icon": "",
      "color": "grey darken-3"
    }
  }, [_c('v-icon', {
    attrs: {
      "color": "white"
    }
  }, [_vm._v("watch_later")])], 1) : _vm._e()], 1) : _vm._e()], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-633f332a","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/AudioImageWithOverlay.vue
// module id = 376
// module chunks = 0